export default "__VITE_ASSET__1gWtp1oS__"